import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import ReactGA from 'react-ga4'
import { IDENTITY_CONFIG } from './auth/utils/authConst'
import { Buffer } from 'buffer'

window.Buffer = window.Buffer || Buffer

const setupGoogleAnalytics = () => {
  const gaDashboardId = process.env.REACT_APP_GA_ID || 'NotSet'
  if(gaDashboardId === 'NotSet') return

  ReactGA.initialize(gaDashboardId)

  const userData = window.localStorage.getItem(`oidc.user:${IDENTITY_CONFIG.stsAuthority}:${IDENTITY_CONFIG.clientId}`)
  if (userData) {
    const userId = JSON.parse(userData).profile.id
    ReactGA.set({ userId })
  }
}

setupGoogleAnalytics()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
